import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { CsIconModule } from '@components/icon';
import { WaitingForCallComponent } from '@shared/waiting-for-call/waiting-for-call.component';
import { EventLoggerService } from '@services/event-logger-service';
import { TimeService } from '@services/time-service';

@Component({
  selector: 're-acquistion-waiting-for-call-sheet',
  imports: [
    CommonModule,
    CsIconModule,
    WaitingForCallComponent,
  ],
  templateUrl: './re-acquisition-waiting-for-call-sheet.component.html',
})
export class ReAcquisitionWaitingForCallSheetComponent {
  constructor(
    private readonly bottomSheetRef: MatBottomSheetRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private readonly eventLogger: EventLoggerService,
    public readonly timeService: TimeService
  ) {}

  ngOnInit(): void {
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'reacquisition_doctor_call_scheduled', type: 'bottom_sheet' }));
  }

  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
  }

  onContinue(): void {
    this.bottomSheetRef.dismiss();
    this.data.onContinue();
  }
}
